import React from 'react';
import { motion } from 'framer-motion';
export function TransformationSection() {
  return <section className="bg-navy-light py-16 md:py-24 px-4" data-id="element-198">
      <div className="max-w-4xl mx-auto" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-200">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-12 text-center" data-id="element-201">
            ¿Qué cambia cuando lo usás?
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-202">
            {/* Before */}
            <div className="bg-navy-dark p-8 rounded-2xl border border-red-500/30 relative overflow-hidden" data-id="element-203">
              <div className="absolute top-0 left-0 w-full h-1 bg-red-500" data-id="element-204"></div>
              <p className="text-xl text-gray-400 mb-6 font-medium" data-id="element-205">
                Pasás de esto:
              </p>
              <ul className="space-y-4" data-id="element-206">
                <li className="flex items-center gap-3 text-lg" data-id="element-207">
                  <span className="text-red-500" data-id="element-208">❌</span>
                  <span className="text-gray-300" data-id="element-209">Caos</span>
                </li>
                <li className="flex items-center gap-3 text-lg" data-id="element-210">
                  <span className="text-red-500" data-id="element-211">❌</span>
                  <span className="text-gray-300" data-id="element-212">Estrés</span>
                </li>
                <li className="flex items-center gap-3 text-lg" data-id="element-213">
                  <span className="text-red-500" data-id="element-214">❌</span>
                  <span className="text-gray-300" data-id="element-215">Desorden</span>
                </li>
                <li className="flex items-center gap-3 text-lg" data-id="element-216">
                  <span className="text-red-500" data-id="element-217">❌</span>
                  <span className="text-gray-300" data-id="element-218">Clientes perdidos</span>
                </li>
              </ul>
            </div>

            {/* After */}
            <div className="bg-navy-dark p-8 rounded-2xl border border-green-500/50 relative overflow-hidden shadow-[0_0_30px_rgba(34,197,94,0.1)]" data-id="element-219">
              <div className="absolute top-0 left-0 w-full h-1 bg-green-500" data-id="element-220"></div>
              <p className="text-xl text-gold mb-6 font-bold" data-id="element-221">A esto:</p>
              <ul className="space-y-4" data-id="element-222">
                <li className="flex items-center gap-3 text-lg" data-id="element-223">
                  <span className="text-green-500" data-id="element-224">✅</span>
                  <span className="text-white font-medium" data-id="element-225">Control total</span>
                </li>
                <li className="flex items-center gap-3 text-lg" data-id="element-226">
                  <span className="text-green-500" data-id="element-227">✅</span>
                  <span className="text-white font-medium" data-id="element-228">
                    Claridad diaria
                  </span>
                </li>
                <li className="flex items-center gap-3 text-lg" data-id="element-229">
                  <span className="text-green-500" data-id="element-230">✅</span>
                  <span className="text-white font-medium" data-id="element-231">
                    Seguimiento constante
                  </span>
                </li>
                <li className="flex items-center gap-3 text-lg" data-id="element-232">
                  <span className="text-green-500" data-id="element-233">✅</span>
                  <span className="text-white font-medium" data-id="element-234">Más ingresos</span>
                </li>
                <li className="flex items-center gap-3 text-lg" data-id="element-235">
                  <span className="text-green-500" data-id="element-236">✅</span>
                  <span className="text-white font-medium" data-id="element-237">
                    Más tiempo libre
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-navy-dark p-8 md:p-12 rounded-2xl border-l-4 border-gold text-center max-w-3xl mx-auto" data-id="element-238">
            <h3 className="text-3xl font-bold text-white mb-8" data-id="element-239">
              La diferencia clave
            </h3>
            <div className="space-y-6 text-xl text-gray-300" data-id="element-240">
              <p data-id="element-241">Esto no depende de tu motivación.</p>
              <p data-id="element-242">No depende de que "te organices mejor".</p>
              <p className="text-2xl font-bold text-gold pt-4" data-id="element-243">
                👉 Depende de tener un sistema que funcione aunque vos estés
                ocupado.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}